import cx from 'classnames';

import { FacingMode, OnStageUser } from 'types';
import { Button, Speaker } from 'components';
import { AddUserIcon, PendingIcon } from 'components/Icon';

export type StageSeatProps = {
  seatIndex?: number;
  type: 'pending' | 'filled' | 'empty';
  activeSpeakerUsername?: string;
  squared?: boolean;
  withAudioIcon?: boolean;
  withoutVideo?: boolean;
  userType?: 'local' | 'remote';
  facingMode?: FacingMode;
  isGridItem?: boolean;
  user?: OnStageUser;
  onClick?(): void;
};

const StageSeat = ({
  seatIndex,
  type,
  squared,
  withAudioIcon = false,
  withoutVideo = false,
  activeSpeakerUsername,
  userType = 'remote',
  facingMode = FacingMode.FRONT,
  isGridItem = false,
  user,
  onClick
}: StageSeatProps) => {
  switch (type) {
    case 'filled': {
      return (
        <Speaker
          seatIndex={seatIndex}
          fit="cover"
          squared={squared}
          isGridItem={isGridItem}
          withAudioIcon={withAudioIcon}
          active={user?.isSpeaking}
          isActiveSpeaker={activeSpeakerUsername === user?.username}
          name={user?.name}
          image={user?.image}
          type={userType}
          facingMode={facingMode}
          audioTrack={user?.audioTrack}
          videoTrack={withoutVideo ? undefined : user?.videoTrack}
          videoMuted={user?.videoMuted}
          audioMuted={user?.audioMuted}
          onClick={onClick}
        />
      );
    }

    case 'pending':
      return (
        <Button className={cx({ 'h-64': !squared })} variant="icon" size="lg" onClick={onClick}>
          <PendingIcon width={squared ? 22 : 24} height={squared ? 22 : 24} />
        </Button>
      );

    case 'empty':
      return (
        <Button className={cx({ 'h-64': !squared })} variant="icon" size="lg" onClick={onClick}>
          <AddUserIcon />
        </Button>
      );

    default:
      return null;
  }
};

export default StageSeat;
